export const LOGIN_CTA = 'Sign in to view'
export const REQUEST_CTA = 'Request data access to view'
export const GATED_DATA_LOGIN_MESSAGE =
  'Sign in to access foreclosures and housing court data. You will need approval to view protected datasets.'